module.exports = __webpack_public_path__ + "static/media/additional_driver.b68950b0.svg";